import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { Typography, Button, OutlineButton } from 'components/atoms';
import { Modal } from 'components/molecules';
import { Box } from 'rebass';

const AllowButton = styled(Button)`
  color: white !important;
  background: linear-gradient(270.02deg, #fdb913 0.02%, #f2994a 99.98%);
  margin: 0.5rem;
  width: 100%;
`;
const CancelButton = styled(OutlineButton)`
  color: white !important;
  border: 2px solid #272729;
  border-radius: 175.5px;
  font-weight: 500;
  margin: 0.5rem;
  width: 100%;
`;

const PushPermissionModal = ({ close, isOpen, requestPermission, toggle }) => {
  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle} size="sm" showCloseIcon>
        <Modal.Header justifyContent="center">
          <Typography.Paragraph textTransform="uppercase" size="small" weight="bold">
            Subscribe to push notifications
          </Typography.Paragraph>
        </Modal.Header>
        <Modal.Body>
          <Box mb="1rem">
            <Typography.Paragraph size="small" color="switchingText" align="center">
              Subscribe to be the first to hear about latest releases and news.
            </Typography.Paragraph>
          </Box>
          <Box display="flex">
            <AllowButton
              onClick={requestPermission}
              size="small"
              effect
              style={{ background: 'linear-gradient(270.02deg, #FDB913 0.02%, #F2994A 99.98%)' }}
            >
              Allow
            </AllowButton>

            <CancelButton onClick={close} effect size="small">
              No, thanks
            </CancelButton>
          </Box>
        </Modal.Body>
      </Modal>
    </>
  );
};

PushPermissionModal.propTypes = {
  close: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  requestPermission: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default PushPermissionModal;
